module.exports = __webpack_public_path__ + "img/shop.a27fd320.svg";